(function($){
    $('body').on('click', '.dpd-btn button', function (e) {
        e.preventDefault();
        $('#dpd_pickup_point_id_field + a').click();
    });
})(jQuery)